<div class="program-header">
  <div class="program-header__row">
    @if (!hideTitle) {
      <h1 class="program-header__title headline5">{{ displayTitle }}</h1>
    }

    <div class="program-header__actions">
      <ptl-button
        type="secondary-neutral"
        [icon]="LucideLanguages"
        [iconSuffix]="LucideChevronDown"
        [matMenuTriggerFor]="languageMenu"
        *ngIf="availableLanguages?.length > 1"
      ></ptl-button>

      <mat-menu #languageMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let language of availableLanguages"
          class="language-menu-item"
          [class.is_active]="language.code === selectedLanguageCode"
          [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
          (click)="languageSelect(language.code)"
          [value]="language.code"
        >
          {{ language.code.toUpperCase() }}
        </button>
      </mat-menu>

      <ptl-button type="secondary-neutral" [icon]="LucideShare2" (click)="shareProgram()"></ptl-button>

      <!-- TODO: Revert for next release - unhide save button for cards -->
      <ptl-button
        *ngIf="!isCard"
        type="secondary-neutral"
        [icon]="$any(program)?.favorite ? LucideBookmark : LucideBookmarkCheck"
        (click)="saveItem()"
      ></ptl-button>

      <ptl-button type="secondary-neutral" [icon]="LucideDownload" (click)="downloadReport()">
        <mat-spinner *ngIf="downloadInProgress" [diameter]="20"></mat-spinner>
      </ptl-button>
    </div>
  </div>

  <div class="card-view__report-container" *ngIf="report">
    <ptl-playlist-report #playlistReportComponent [report]="report" (pdfDownloaded)="onReportDownloaded()" (pdfError)="onReportPdfError()">
    </ptl-playlist-report>
  </div>
</div>
